import { Component, Inject, Optional } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { HotToastRef } from '@ngxpert/hot-toast';

interface DataType {
  onClick: () => void;
}

@Component({
  standalone: true,
  imports: [MatButtonModule],
  selector: 'fz-user-has-pass-available',
  templateUrl: './user-has-pass-available.component.html',
  styleUrls: ['./user-has-pass-available.component.scss'],
})
export class UserHasPassAvailableComponent {
  constructor(
    @Optional() @Inject(HotToastRef) public toastRef: HotToastRef<DataType>,
  ) {}

  /**
   * Function to be called when the button is clicked, it reload the page
   */
  onClick(): void {
    if (this.toastRef) {
      this.toastRef.data.onClick();
      this.toastRef.close();
    } else {
      window.location.reload();
    }
  }
}
